import {
  GSIS_EMPLOYEE_SHARE_KEYS,
  GSIS_LOAN_FIELDS,
} from "../payrollReportConfig";
import {
  buildEmployeeAmountPipeline,
  buildEmployeeSummaryPipeline,
  buildNamedContributionSum,
  buildPayrollAmountLookups,
  ENTRY_AMOUNT_PERIOD_SUM,
  ENTRY_KEY,
} from "./shared";

const GSIS_EMPLOYEE_SHARE_SUM = buildNamedContributionSum(
  GSIS_EMPLOYEE_SHARE_KEYS,
);
const GSIS_LOAN_KEYS = GSIS_LOAN_FIELDS.map(({ key }) => key);

/**
 * GSIS loan reporting needs 12 totals from the same array. Parsing
 * "name: amount" once per row keeps it to a single pass over deductions.
 */
const GSIS_LOAN_STAGES = [
  { $match: { deductions: { $regex: "^dueToGsis" } } },
  {
    $addFields: {
      gsisLoanEntries: {
        $map: {
          input: { $ifNull: ["$deductions", []] },
          in: { k: ENTRY_KEY, v: ENTRY_AMOUNT_PERIOD_SUM },
        },
      },
    },
  },
];

function sumParsedGsisLoans(keys) {
  return {
    $sum: {
      $map: {
        input: {
          $filter: {
            input: "$gsisLoanEntries",
            cond: { $in: ["$$this.k", keys] },
          },
        },
        in: "$$this.v",
      },
    },
  };
}

export const GSIS_LOAN_SUMS = Object.fromEntries([
  ...GSIS_LOAN_KEYS.map((key) => [key, sumParsedGsisLoans([key])]),
  ["totalGsisLoan", sumParsedGsisLoans(GSIS_LOAN_KEYS)],
]);

export const GSIS_EMPLOYEE_SHARE_LOOKUPS = buildPayrollAmountLookups(
  "gsisEmployeeShare",
  "employeeShare",
  GSIS_EMPLOYEE_SHARE_SUM,
);

export function getGsisEmployeeShareByEmployeePipeline(employeeIds = []) {
  return buildEmployeeAmountPipeline(
    employeeIds,
    "employeeShare",
    GSIS_EMPLOYEE_SHARE_SUM,
  );
}

export function getGsisLoansByEmployeePipeline(employeeIds = []) {
  return buildEmployeeSummaryPipeline(
    employeeIds,
    GSIS_LOAN_SUMS,
    GSIS_LOAN_STAGES,
  );
}
